import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductCollectionInfoComponent from './product-collection-info.component';
import CategoryCollectionInfoComponent from './category-collection-info.component';
import TabContainer from '../../../../../../../common/components/tab/containers/tab.containers';




export const GlobalOrgRegistryMappingsDetails = ({orgRegistryId,id,back}) => {
    
 const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
      const [searchParams, setSearchParams] = useSearchParams();

  const tabItems = [
  
    
    {
      id: 2,
      title: 'Product Collections',
      component: (
          <ProductCollectionInfoComponent  globalOrgRegistryId ={orgRegistryId}
          accountId ={id} />
      ),
      isVisible: true, 
  },

  {
    id: 3,
    title: 'Category Collections',
    component: (
        <CategoryCollectionInfoComponent  globalOrgRegistryId ={orgRegistryId}
        accountId ={id}  />
    ),
    isVisible: true, 
},
    
  ];

useEffect(() => {
            const tabTitleFromURL = searchParams.get('tab');
            if (tabTitleFromURL) {
                const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
                if (tabIndex !== -1) {
                    setSelectedTabIndex(tabIndex);
                }
            } else {
                setSelectedTabIndex(0);
            }
        }, [searchParams]);
    
        const handleTabChange = (index: number) => {
            setSelectedTabIndex(index);
            setSearchParams({ tab: tabItems[index].title });
        };
    
        if (selectedTabIndex === null) {
            return null;
        }
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
        
      <TabContainer tabItems={tabItems}   selectedIndex={selectedTabIndex}
            onChange={handleTabChange}  />
      <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
      </div>
    </div>
  );
};

export default GlobalOrgRegistryMappingsDetails;
